<div class="row">
    <div class="col-sm-12">
        <div class="form-group row">
            <label class="col-xs-12">Type de la commande : <span>{{orderTypeLabel}}</span></label>
        </div>
        <div class="form-group row">
            <label class="col-xs-12">Prévu pour : {{orderProg|date:'HH:mm'}}</label>
        </div>
        <div class="form-group row" *ngIf="chosenOrderType==1">
            <label class="col-xs-12">Adresse:
                <span>{{address.streetNumber}} {{address.streetName}} ( {{address.city}}
                    {{address.postalCode}})</span>
            </label>
        </div>
        <div class="form-group row" *ngIf="chosenOrderType==1">
            <label class="col-xs-12">
                <p>
                    Compléments adresse:
                </p>
                <textarea class="form-control" style="width : 100%"
                    placeholder="Addresse complémentaire: Etage,porte..." [(ngModel)]="address.complementAddress"
                    name="complementAddress" id="" cols="30" rows="3"></textarea>
            </label>
        </div>
        <div class="form-group row">
            <label class="col-xs-12">
                <p>
                    Commentaire :
                </p>
                <textarea name="comment" [(ngModel)]="order.comment" class="form-control" id="" cols="30"
                    rows="3"></textarea>
            </label>
        </div>
        <div class="form-group row" *ngIf="enablePayement">
            <div class="col-xs-12">
                <label>Paiement sécurisé:</label>
                <div class="list list-options">
                    <div class="list-item brdb pbxl">
                        <input id="Cod_ParCB" name="payamentmode" [(ngModel)]="payamentmode" class="osh-radio option"
                            type="radio" [value]="1">
                        <label class="fwm" for="Cod_ParCB">
                            <span class="-prm gradient-border" id="box">
                                <img src="assets/images/payement.jpg" alt="Paiement par carte bancaire">
                            </span>
                            <span class="d-block">
                                Paiement par carte bancaire
                            </span>
                        </label>
                        <div class="subtitle">
                            Priviligiez le paiement sans contact en payant en ligne avec votre carte bancaire, moyen
                            sécurisé et facile.
                        </div>
                    </div>
                    <div class="list-item brdb pbxl">
                        <input id="Cod_CashOnDelivery" name="payamentmode" [(ngModel)]="payamentmode"
                            class="osh-radio option" type="radio" [value]="2">
                        <label class="fwm" for="Cod_CashOnDelivery"><span class="-prm"><img
                                    src="assets/images/service-cash.png" alt=""></span>
                            Paiement à la livraison</label>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="payementModes.length > 0 && payamentmode==2" class="form-group row">
            <label class="control-label col-md-4">Mode de réglement :</label>
            <div class="col-md-12 payementModes">
                <div class="check-group" *ngFor="let pm of payementModes;let i=index">
                    <onoffswitch [(ngModel)]="pm.checked" [label]="pm.text" [available]="true" placement="bottom">
                    </onoffswitch>
                </div>
                <br>
                <span class="required" *ngIf="orderErreurModePaimenet">Choisissez un mode de paiement</span>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-md-4">Vous avez un code promo ?</label>
            <div class="col-md-8">
                <input [disabled]="couponAdded" [(ngModel)]="coupon" type="text" style="padding: 10px!important;"
                    class="form-control mb-1" placeholder="Entrez ici votre coupon de réduction">
                <div class="coupon-btn pull-right" [class.couponAdded]="couponAdded">
                    <button class="btn btn-default" *ngIf="!couponAdded" type="button" (click)="addCoupon()">Ajouter
                        le coupon</button>
                    <button class="btn btn-danger" *ngIf="couponAdded" type="button" (click)="removeCoupon()">Retirer le
                        coupon</button>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between" *ngIf="order.discount>0 || order.coupon>0 || order.fees>0">
            <p>
                <b>Sous-total :</b>
            </p>
            <div>
                {{order.amount | number : '1.2-2'}} €
            </div>
        </div>
        <div class="d-flex justify-content-between" *ngIf="order.discount>0">
            <p>
                <b>Remise {{order.discount}}% :</b>
            </p>
            <div>
                {{-order.discountValue | number : '1.2-2'}} €
            </div>
        </div>
        <div class="d-flex justify-content-between" *ngIf="order.coupon>0">
            <p>
                Coupon {{order.coupon}} <ng-container *ngIf="order.couponType==1">€</ng-container>
                <ng-container *ngIf="order.couponType==2">%</ng-container>
            </p>
            <div>
                {{order.couponValue | number : '1.2-2'}} €
            </div>
        </div>
        <div class="d-flex justify-content-between" *ngIf="order.fees>0">
            <p>
                {{order.feesLabel}} :
            </p>
            <div>
                {{order.fees | number : '1.2-2'}} €
            </div>
        </div>
        <div class="d-flex ttc">
            <p>
                <b>Total TTC : &nbsp;</b>
            </p>
            <p>
                <b>{{order.total | number : '1.2-2'}} €</b>
            </p>
        </div>
        <div class="text-center back">
            <button (click)="back()">
                <img src="assets/images/icons/left.png" width="30px" alt="left">
            </button>
        </div>
        <div class="text-center validate" [ngClass]="{'inLoading':loader}">
            <button (click)="save()" [disabled]="loader">
                <span *ngIf="!loader">Valider la commande</span>
            </button>
            <div *ngIf="loader" id="loadingPage"></div>
        </div>
    </div>
</div>